export default {
    GENERIC: "GENERIC",
    REWARD: "REWARD",
    CLIENT: "CLIENT",
};
